import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-41456e3f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "exam-scope mohu"
};
const _hoisted_2 = {
  class: "con",
  "element-loading-text": "数据加载中..."
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, "研究方向", -1));
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = {
  style: {
    "height": "100%",
    "flex": "1",
    "display": "flex",
    "align-items": "center",
    "border-right": "1px solid #dcdfe6"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, "政治", -1));
const _hoisted_9 = {
  class: "right"
};
const _hoisted_10 = {
  style: {
    "height": "100%",
    "flex": "1",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, "英语", -1));
const _hoisted_12 = {
  class: "right"
};
const _hoisted_13 = {
  class: "item"
};
const _hoisted_14 = {
  style: {
    "height": "100%",
    "flex": "1",
    "display": "flex",
    "align-items": "center",
    "border-right": "1px solid #dcdfe6"
  }
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, "专业课一", -1));
const _hoisted_16 = {
  class: "right"
};
const _hoisted_17 = {
  style: {
    "height": "100%",
    "flex": "1",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, "专业课二", -1));
const _hoisted_19 = {
  class: "right"
};
const _hoisted_20 = {
  class: "item",
  style: {
    "text-align": "center",
    "width": "100%",
    "display": "block",
    "padding": "3px 0"
  }
};
const _hoisted_21 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
const _hoisted_23 = {
  key: 1,
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_24 = {
  class: "table"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "初试参考书目")], -1));
const _hoisted_26 = {
  class: "mohu",
  style: {
    "padding": "20px"
  }
};
const _hoisted_27 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
const _hoisted_29 = {
  class: "table",
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "复试参考书目")], -1));
const _hoisted_31 = {
  class: "mohu",
  style: {
    "padding": "20px"
  }
};
const _hoisted_32 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
import { Bell } from "@element-plus/icons-vue";
import { ref, onMounted } from "vue";
import { examRange, earlyRefer, fuRefer } from "@/api/api";
import { decrypt } from "@/utils/parseDate";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
export default {
  __name: 'ExamScope',
  props: {
    majorId: String
  },
  emits: ["onChange"],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    const store = useStore();

    // 点击tab
    const activeName = ref(1);
    const handleClick = event => {
      console.log(event);
      if (event == 1) {} else if (event == 2) {}
    };
    // 点击解锁
    function onUnlock() {
      emit("onChange", {
        isUnlock: true
      });
    }
    const tableData1 = ref([]);
    const tableData2 = ref([]);
    // 所有数据
    const allData = ref([]);
    // 加载状态
    const loading = ref(false);
    const obj = ref({});
    // 是否显示模糊效果
    const isUnlock = ref(false);
    // 初试参考书目
    async function getEarlyRefer() {
      try {
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await earlyRefer(data);
        const res = JSON.parse(decrypt(result));
        console.log(res, 2);
        if (res.status == 8) {
          store.commit("setTipsDialog", true);
        }
        if (res.status == 9) {
          store.commit("setNumberDialog", true);
        }
        if (res.status == 666) {
          ElMessage({
            message: res.msg,
            type: "warning",
            showClose: true
          });
          isUnlock.value = true;
          emit("onChange", {
            isUnlock: true
          });
          tableData1.value = [{
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }];
          loading.value = false;
        }
        if (res.status === 0 && res.result.length > 0) {
          allData.value = res.result;
          tableData1.value = res.result;
          loading.value = false;
          isUnlock.value = false;
        } else {
          tableData1 = [];
          allData = [];
          selectYear.value = "";
          yearOptions.value = [];
          loading.value = false;
        }
      } catch (error) {
        loading.value = false;
        // throw new Error(error)
      }
    }
    // 复试参考书目
    async function getFuRefer() {
      try {
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await fuRefer(data);
        const res = JSON.parse(decrypt(result));
        console.log(res, 2);
        if (res.status == 666) {
          ElMessage({
            message: res.msg,
            type: "warning",
            showClose: true
          });
          isUnlock.value = true;
          emit("onChange", {
            isUnlock: true
          });
          tableData2.value = [{
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            researchDirection: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }];
          loading.value = false;
        }
        if (res.status === 0 && res.result.length > 0) {
          allData.value = res.result;
          tableData2.value = res.result;
          loading.value = false;
          isUnlock.value = false;
        } else {
          tableData2 = [];
          allData = [];
          selectYear.value = "";
          yearOptions.value = [];
          loading.value = false;
        }
      } catch (error) {
        loading.value = false;
        // throw new Error(error)
      }
    }
    // 获取考试范围
    async function getExamRange() {
      try {
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await examRange(data);
        const res = JSON.parse(decrypt(result));
        console.log(res);
        if (res.status == 666) {
          ElMessage({
            message: res.msg,
            type: "warning",
            showClose: true
          });
          isUnlock.value = true;
          emit("onChange", {
            isUnlock: true
          });
          obj.value = {
            researchDirection: "请解锁查看",
            examContentsPolitics: "请解锁查看",
            examContentsEnglish: "请解锁查看",
            examContentsOther1: "请解锁查看",
            examContentsOther2: "请解锁查看",
            examContents: "请解锁查看"
          };
        }
        if (res.status === 0) {
          isUnlock.value = false;
          obj.value = res.result;
        }
        loading.value = false;
      } catch (error) {
        loading.value = false;
        // throw new Error(error)
      }
    }
    // 将 myMethod 暴露给父组件
    __expose({
      childMethod
    });
    function childMethod() {
      getExamRange();
      getEarlyRefer();
      getFuRefer();
    }
    onMounted(() => {
      getExamRange();
      getEarlyRefer();
      getFuRefer();
    });
    // 合并表头
    function headerCellStyle({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      // 由于是多级表头 -- 合并目标表头在第三层 -- 寻找第三级表头
      if (row[0].level === 2) {
        row[0].colSpan = 3;
        row[1].colSpan = 0;
        row[2].colSpan = 0;
        // 根据列数进行样式赋予
        if (columnIndex === 1 || columnIndex === 0 || columnIndex === 2) {
          return {
            display: "none"
          };
        }
      }
      // return {
      //   color: "#333333",
      //   fontWeight: "bold",
      //   textAlign: "center",
      // };
    }
    // 合并表尾
    function getSummaries() {
      return ["", "", "", ""];
    }
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_Key = _resolveComponent("Key");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
        class: "demo-tabs",
        onTabChange: handleClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "初试考试范围",
          name: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "参考书目",
          name: 2
        })]),
        _: 1
      }, 8, ["modelValue"]), activeName.value == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(obj.value.researchDirection), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString(obj.value.examContentsPolitics), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(obj.value.examContentsEnglish), 1)])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(obj.value.examContentsOther1), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, _toDisplayString(obj.value.examContentsOther2), 1)])]), _createElementVNode("div", _hoisted_20, _toDisplayString(obj.value.examContents) + "  ", 1)])), [[_directive_loading, loading.value]]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_el_button, {
        type: "success",
        onClick: onUnlock
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_Key)]),
          _: 1
        }), _createTextVNode(), _hoisted_22]),
        _: 1
      })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activeName.value == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_card, {
        shadow: "hover"
      }, {
        header: _withCtx(() => [_hoisted_25]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          stripe: "",
          "element-loading-text": "数据加载中...",
          "empty-text": "暂无数据，请重新选择条件查询",
          data: tableData1.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "schoolName",
            label: "学校名称"
          }), _createVNode(_component_el_table_column, {
            prop: "majorCourseCode",
            label: "专业课代码"
          }), _createVNode(_component_el_table_column, {
            prop: "majorCourseName",
            label: "专业课名称"
          }), _createVNode(_component_el_table_column, {
            prop: "referBook",
            label: "参考书目名称"
          }), _createVNode(_component_el_table_column, {
            prop: "publishClub",
            label: "出版社"
          }), _createVNode(_component_el_table_column, {
            prop: "author",
            label: "作者"
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_button, {
          type: "success",
          onClick: onUnlock
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_Key)]),
            _: 1
          }), _hoisted_28]),
          _: 1
        })])) : _createCommentVNode("", true)])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_card, {
        shadow: "hover"
      }, {
        header: _withCtx(() => [_hoisted_30]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          stripe: "",
          "element-loading-text": "数据加载中...",
          "empty-text": "暂无数据，请重新选择条件查询",
          data: tableData2.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "schoolName",
            label: "学校名称"
          }), _createVNode(_component_el_table_column, {
            prop: "majorCourseCode",
            label: "专业课代码"
          }), _createVNode(_component_el_table_column, {
            prop: "majorCourseName",
            label: "专业课名称"
          }), _createVNode(_component_el_table_column, {
            prop: "researchDirection",
            label: "研究方向名称"
          }), _createVNode(_component_el_table_column, {
            prop: "referBook",
            label: "参考书目名称"
          }), _createVNode(_component_el_table_column, {
            prop: "publishClub",
            label: "出版社"
          }), _createVNode(_component_el_table_column, {
            prop: "author",
            label: "作者"
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_button, {
          type: "success",
          onClick: onUnlock
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_Key)]),
            _: 1
          }), _hoisted_33]),
          _: 1
        })])) : _createCommentVNode("", true)])]),
        _: 1
      })])])) : _createCommentVNode("", true)]);
    };
  }
};